const getToken = state => state?.auth?.token
const getInstituteCampusId = state => state?.auth?.instituteCampusId
const getInstituteDetails = state => state?.auth?.instituteDetails
const getUserRoleList = state => state?.auth?.userRoleList
const getUserId = state => state?.auth?.userId
const getUserInfo = state => state?.auth?.userData
const getListOfCountries = state => state?.auth?.listOfCountries
const getListOfStates = state => state?.auth?.listOfStates
const getListOfCities = state => state?.auth?.listOfCities
const getNotifications = state => state?.auth?.notifications
const getUserPermissions = state => state?.auth?.permissions

const selectors = {
  getToken,
  getInstituteCampusId,
  getInstituteDetails,
  getUserRoleList,
  getUserId,
  getUserInfo,
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  getNotifications,
  getUserPermissions

}

export default selectors
